import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import Button from 'react-toolbox/lib/button';
import style from './CustomButton.scss';// to import local scss fle

const CustomButton = (props) => {
  const onClickHandler = () => {
    props.onClick();
  };

  return (
    <div className={props.label === 'NEXT' ? style.customButtonContainerForCoach : cn(style.customButtonContainer, props.style)}>
      <Button type="submit" label={props.label} className={style.customButton} onClick={onClickHandler} />
    </div>);
};

CustomButton.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  style: PropTypes.string,
};

CustomButton.defaultProps = {
  onClick: () => {},
  label: 'SUBMIT',
  style: '',
};

export default CustomButton;



// WEBPACK FOOTER //
// ./src/components/CustomButton/CustomButton.js